// :cow: Cosmose CONFIDENTIAL :iso:
import { Action, createReducer, on } from '@ngrx/store';
import {
  addToGroupRequested,
  addToGroupRequestError,
  addToGroupRequestSuccess,
  groupsRequested,
  groupsRequestError,
  groupsRequestSuccess,
} from './add-to-group.actions';
import { GroupsResponse } from '@coa/app/shared/add-to-group-dialog/modules/add-to-group/models/groups.response';

export const STATE_NAME = 'add-to-group';

export interface State {
  isLoading: boolean;
  isError: boolean;
  groupsResponse: GroupsResponse;
  isAdding: boolean;
}

const initialState: State = {
  isLoading: false,
  isError: false,
  groupsResponse: undefined,
  isAdding: false,
};

const reducer = createReducer(
  initialState,
  on(groupsRequested, (state) => ({...state, groupsResponse: undefined, isLoading: true, isError: false})),
  on(groupsRequestSuccess, (state, {groupsResponse}) => ({...state, groupsResponse, isLoading: false})),
  on(groupsRequestError, (state) => ({...state, isLoading: false, isError: true})),

  on(addToGroupRequested, (state) => ({...state, isAdding: true})),
  on(addToGroupRequestSuccess, (state) => ({...state, isAdding: false})),
  on(addToGroupRequestError, (state) => ({...state, isAdding: false})),
);

export function addToGroupReducer(state: State | undefined, action: Action): any {
  return reducer(state, action);
}

